<div class="w-full md:w-[768px] xl:w-[1280px] mx-auto px-4 md:px-5 pt-6 md:pt-10 pb-20 md:pb-15">

  <!-- Loading -->
  @if (loading()) {
    <div class="flex justify-center items-center py-20">
      <mat-spinner diameter="48" />
    </div>
  }

  <!-- Not Found -->
  @else if (notFound()) {
    <div class="py-20 text-center">
      <p class="text-gray-400 text-lg">Company not found.</p>
      <a routerLink="/companies" mat-stroked-button class="mt-4">
        Back to Companies
      </a>
    </div>
  }

  @else if (company()) {

    <!-- Breadcrumbs -->
    <nav class="flex items-center gap-2 text-sm text-gray-500 mb-6">
      <a routerLink="/" class="hover:text-gray-800 transition-colors">Home</a>
      <span>/</span>
      <a routerLink="/companies" class="hover:text-gray-800 transition-colors">Companies</a>
      <span>/</span>
      <span class="text-gray-800 font-medium">{{ company()!.name }}</span>
    </nav>

    <!-- Hero Image -->
    @if (company()!.heroImage) {
      <div class="w-full mb-7 rounded-2xl overflow-hidden bg-gray-100">
        <img
          [src]="company()!.heroImage"
          [alt]="company()!.name"
          class="w-full object-cover block"
          style="aspect-ratio: 1600 / 500"
          loading="eager"
        />
      </div>
    }

    <!-- Profile Header Card -->
    <div class="border border-gray-200 rounded-2xl bg-white p-4 md:p-7 mb-6 md:mb-8 shadow-xs">
      <div class="flex items-start gap-4 md:gap-7">
    
        <!-- Logo -->
        <div class="shrink-0 w-20 h-20 md:w-44 md:h-44 border border-gray-100 rounded-2xl bg-white flex items-center justify-center p-2 md:p-5 overflow-hidden">
          @if (logo()) {
            <img
              [src]="logo()"
              [alt]="company()!.name + ' logo'"
              class="w-full h-full object-contain"
            />
          } @else {
            <span class="text-[10px] leading-tight text-gray-400 text-center px-1">
              No logo available
            </span>
          }
        </div>
    
        <!-- Right side: title + actions -->
        <div class="min-w-0 flex-1">
          <div class="flex flex-col gap-2">
            <h1 class="text-2xl md:text-4xl font-bold leading-tight mt-0 mb-0">
              {{ company()!.name }}
            </h1>
    
            <div class="flex flex-wrap gap-2">        
              <button
                mat-flat-button
                color="primary"
                type="button"
                (click)="openApplicationModal()"
              >
                Apply Now →
              </button>
    
              @if (phone()) {
                <a
                  [href]="'tel:' + phoneHref()"
                  mat-stroked-button
                >
                  {{ phone() }}
                </a>
              }
            </div>
    
            @if (socialLinks().length > 0) {
              <div class="flex gap-2 flex-wrap items-center">
                @for (link of socialLinks(); track link.network) {
                  <a
                    [href]="link.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    [title]="link.label"
                    [attr.aria-label]="link.label"
                    class="border border-gray-200 rounded-full p-2"
                  >
                  <img class="w-6 h-6 object-contain" [src]="link.icon" [alt]="link.label" />
                  </a>
                }
              </div>
            }
          </div>
    
          
        </div>
        
      </div>
      @if (description()) {
        <div class="mt-3 text-sm md:text-base leading-relaxed text-gray-600 prose prose-sm max-w-none prose-compact">
          <div [innerHTML]="descriptionDisplay() | youtubeEmbed"></div>
      
          @if (descriptionCanToggle()) {
            <button
              type="button"
              mat-button
              class="mt-2 px-0 text-blue-600"
              (click)="toggleDescription()"
            >
              {{ descriptionExpanded() ? 'Hide' : 'Show more' }}
            </button>
          }
        </div>
      }          
      
    </div>
    
    
    
    

<!-- Two Column Layout -->
<!--
On mobile: jobs first, sidebar HIDDEN (its content is already
in the header card and the sticky apply bar covers the CTA).
On xl: restore the full two-column layout.
-->
<div class="grid gap-6 md:gap-8 items-start grid-cols-1 xl:grid-cols-[minmax(0,1.35fr)_minmax(320px,0.65fr)]">

<!-- Jobs Column -->
<div id="open-jobs">
<div class="flex items-center justify-between gap-3 mb-4 flex-wrap">
  <div class="flex items-baseline gap-2">
    <h2 class="text-xl md:text-2xl font-semibold m-0">Open Jobs</h2>
    @if (jobs().length > 0) {
      <span class="text-xs md:text-sm text-gray-500">{{ jobs().length }} shown</span>
    }
  </div>

  <a
    [routerLink]="['/jobs']"
    [queryParams]="{ company: company()!.slug }"
    mat-stroked-button
  >
    View All Jobs →
  </a>
</div>

@if (jobsLoading()) {
  <div class="flex items-center justify-center py-8">
    <mat-spinner diameter="32" />
  </div>
} @else if (jobs().length === 0) {
  <p class="text-gray-400 py-4">No open positions at this time.</p>
} @else {
  <div class="grid gap-3 md:gap-5 items-stretch"
       style="grid-template-columns: repeat(auto-fill, minmax(220px, 1fr))">
    @for (job of jobs(); track job.id) {
      <app-job-search-card [job]="job" />
    }
  </div>
}
</div>
</div>


  }

</div>

<!-- Mobile Sticky Apply Bar -->
@if (company()) {
  <div class="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 flex sm:hidden z-50">
    <button
      mat-flat-button
      color="primary"
      class="w-full"
      (click)="openApplicationModal()"
    >
      Apply Now →
    </button>
  </div>
}